<template>
  <mdb-footer>
    <p class="footer-copyright mb-0 py-3 text-center">
      <span> &copy; {{new Date().getFullYear()}}</span> <a href="https://bndbs.ir">تمام حقوق مادی و معنوی این وب سایت محفوظ می باشد و هرگونه کپی برداری از ان پیگرد قانونی دارد.</a>
    </p>
  </mdb-footer>
</template>

<script>
import { mdbFooter } from 'mdbvue'

export default {
  name: 'Footer',
  components: {
    mdbFooter
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
